module.exports = __webpack_public_path__ + "static/media/trial-1-after10sec-if-they-dont-rememeber.fb3120cc.mp3";